import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  TablePagination,
} from '@mui/material';
import { useTranslation } from "react-i18next";

const UserFilterModal = ({ open, onClose, users, initialSelectedUsers, isSidebarOpen }) => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const [selected, setSelected] = useState(new Set(initialSelectedUsers));
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    setSelected(new Set(initialSelectedUsers));
  }, [initialSelectedUsers]);

  const handleUserSelection = (event) => {
    const updated = new Set(selected);
    if (event.target.checked) {
      updated.add(event.target.name);
    } else {
      updated.delete(event.target.name);
    }
    setSelected(updated);
  };

  const filteredUsers = users.filter(user =>
    user.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const paginatedUsers = filteredUsers.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(new Set(users));
    } else {
      setSelected(new Set());
    }
  };

  const handleClose = () => {
    onClose(selected);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={`vis-calendar-filter-users-modal ${isSidebarOpen() ? 'sidebar-open' : ''}`}
    >
      <DialogTitle>{t("calendar.user_select")}</DialogTitle>
      <DialogContent>
        <TextField
          label={t("calendar.search_users")}
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          fullWidth
          margin="normal"
          className="vis-calendar-search-users"
          InputProps={{ className: "white-txt-color" }}
          InputLabelProps={{ className: "white-txt-color" }}
        />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={
                    selected.size > 0 && selected.size < users.length
                  }
                  checked={selected.size === users.length}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell className="white-txt-color">{t("calendar.user")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedUsers.map((user) => (
              <TableRow key={user}>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selected.has(user)}
                    onChange={handleUserSelection}
                    name={user}
                  />
                </TableCell>
                <TableCell className="white-txt-color">{user}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={users.length}
          page={currentPage}
          onPageChange={(e, newPage) => setCurrentPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setCurrentPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
          labelDisplayedRows={({ from, to, count }) =>
            t('table.pagination', { from, to, count })
          }
          labelRowsPerPage={t("table.table_rows")}
          className="vis-calendar-pagination"
        />
      </DialogContent>
    </Dialog>
  );
};

export default UserFilterModal;
